/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

const OPEN_LINK_PATHS = [
  'M11.25 8.125V11.875C11.25 12.5649 10.6899 13.125 10 13.125H3.125C2.43511 13.125 1.875 12.5649 1.875 11.875V5C1.875 4.31011 2.43511 3.75 3.125 3.75H6.875',
  'M9.375 1.875H13.125V5.625',
  'M6.25 8.75L13.125 1.875',
];

const VIEWBOX_SIZE = 15;

/** Default stroke — company theme via `--ds-theme-action-primary`. */
export const OPEN_LINK_ICON_DEFAULT_STROKE = 'var(--ds-theme-action-primary)';

const iconPropTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.shape({}),
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Open / external-link (15×15). Color via `color`, `stroke`, or CSS on `.ds-icon`.
 * Defaults to company theme (`--ds-theme-action-primary`). Pass `aria-label` when used without adjacent text.
 */
const OpenLinkIcon = ({
  size = 15,
  color,
  stroke = OPEN_LINK_ICON_DEFAULT_STROKE,
  strokeWidth = 1.0625,
  className = '',
  style,
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  const resolvedStroke = color || stroke;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${VIEWBOX_SIZE} ${VIEWBOX_SIZE}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={['ds-icon', className].filter(Boolean).join(' ')}
      style={color ? { color, ...style } : style}
      aria-hidden={ariaLabel ? undefined : ariaHidden}
      aria-label={ariaLabel || undefined}
      role={ariaLabel ? 'img' : undefined}
      focusable="false"
      {...props}
    >
      {OPEN_LINK_PATHS.map((d) => (
        <path
          key={d}
          d={d}
          stroke={resolvedStroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}
    </svg>
  );
};

OpenLinkIcon.propTypes = iconPropTypes;

export { OpenLinkIcon };
export default OpenLinkIcon;
